import React, { useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import {
	OpinionsContainer,
	StyledGridContainer,
	StyledProgressGrid,
	StyledDataGrid
} from './styles';
import { useTranslation } from 'react-i18next';
import Animation from '../../../../components/Animation';
import ProgressList from './ProgressList';
import { scrollToOpinionsSelector } from '../../selectors';
import OpinionsList from './OpinionsList';
import TitleWithStars from '../../../../components/Titles/TitleWithStars';

const Opinions = props => {
	const { t } = useTranslation();
	const ref = useRef(null);

	useEffect(() => {
		if (props.scrollToOpinions) {
			ref.current.scrollIntoView({
				behavior: 'smooth',
				block: 'start'
			});
		}
	}, [props.scrollToOpinions]);

	return (
		<OpinionsContainer ref={ref}>
			<Animation animateIn="fadeInDown">
				<TitleWithStars title={t('general.opinions.title')} stars={4} />
			</Animation>
			<StyledGridContainer container>
				<StyledProgressGrid item xs={12} sm={6}>
					<ProgressList />
				</StyledProgressGrid>
				<StyledDataGrid item xs={12} sm={6}>
					<OpinionsList />
				</StyledDataGrid>
			</StyledGridContainer>
		</OpinionsContainer>
	);
};

const mapStateToProps = state => {
	return {
		scrollToOpinions: scrollToOpinionsSelector(state)
	};
};

const mapDispatchToProps = dispatch => {
	return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Opinions);
